var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useRef, useState } from 'react';
import styles from './PositionSelect.module.css';
import { useOutsideClick } from '../hooks';
var PositionSelect = function (_a) {
    var id = _a.id, value = _a.value, onChange = _a.onChange;
    var _b = __read(useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var containerRef = useRef(null);
    var positions = [
        { 'lt': 'Сверху cлева' },
        { t: 'Сверху' },
        { 'rt': 'Сверху cправа' },
        { l: 'Слева' },
        { center: '' },
        { r: 'Справа' },
        { 'lb': 'Снизу cлева' },
        { b: 'Снизу' },
        { 'rb': 'Снизу справа' }
    ];
    var indexValue = positions.findIndex(function (position) { return Object.keys(position)[0] === value; }) || 0;
    var positionTitle = Object.values(positions[indexValue])[0];
    var positionIconСlass = "positionIcon".concat(indexValue);
    useOutsideClick(containerRef, function () { return setIsOpen(false); });
    var handlePanelToggle = function () {
        setIsOpen(function (prevIsOpen) { return !prevIsOpen; });
    };
    var handlePositionSelect = function (index) {
        setIsOpen(false);
        onChange(id, Object.keys(positions[index])[0]);
    };
    return (React.createElement("div", { ref: containerRef, className: styles.container },
        React.createElement("div", { className: styles.containerTitle },
            React.createElement("div", { className: styles.positionTitle }, positionTitle),
            React.createElement("div", { className: isOpen ? styles.positionIconOpen : styles[positionIconСlass], onClick: handlePanelToggle })),
        isOpen && (React.createElement("div", { className: styles.dropdownPanel }, __spreadArray([], __read(Array(3)), false).map(function (_, rowIndex) {
            return (React.createElement("div", { key: rowIndex, className: styles.panelRow }, __spreadArray([], __read(Array(3)), false).map(function (_, elementIndex) {
                var index = 3 * rowIndex + elementIndex;
                var panelElementСlass = index === indexValue
                    ? "panelElementSelect".concat(index)
                    : "panelElement".concat(index);
                return (React.createElement("div", { key: index, className: styles[panelElementСlass], onClick: index !== 4
                        ? function () { return handlePositionSelect(index); }
                        : undefined }));
            })));
        })))));
};
export default PositionSelect;
